exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DrawerContainer {\r\n  width: 100%;\r\n  z-index: 403;\r\n  position: absolute;\r\n  overflow: scroll;\r\n  bottom: 0;\r\n  top: 0;\r\n  background-color: rgba(58, 58, 58, 0.9);\r\n  display: block;\r\n  margin: 0 -20px;\r\n  /*border-top: 1px outset #ffffff;*/\r\n}\r\n\r\n.desktop .DrawerContainer {\r\n  position: relative;\r\n  bottom: 20px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  margin: 0;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/MapContainer/components/DrawerContainer/DrawerContainer.css
// module id = 856
// module chunks = 0